function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Paragraph } from "../../typography/Paragraph";
import { ICON_NAMES_LIST, ICON_NAMES } from "./constants";
import { getPath } from "./utils/getPath";
import { getButtonProps } from "./utils/getButtonProps";
export var Component = function Component(_ref) {
  var className = _ref.className,
      color = _ref.color,
      hasBorder = _ref.hasBorder,
      isCircular = _ref.isCircular,
      isColorInverted = _ref.isColorInverted,
      isDisabled = _ref.isDisabled,
      isLabelLeft = _ref.isLabelLeft,
      isButton = _ref.isButton,
      labelText = _ref.labelText,
      labelWeight = _ref.labelWeight,
      name = _ref.name,
      path = _ref.path,
      size = _ref.size,
      otherProps = _objectWithoutProperties(_ref, ["className", "color", "hasBorder", "isCircular", "isColorInverted", "isDisabled", "isLabelLeft", "isButton", "labelText", "labelWeight", "name", "path", "size"]);

  return React.createElement("i", _extends({
    className: classnames('icon', color, size, className, {
      circular: isCircular,
      'has-border': hasBorder,
      'inverted grey': isDisabled,
      'has-label': !!labelText,
      inverted: isColorInverted,
      'is-button': isButton,
      spinner: name === ICON_NAMES.SPINNER
    })
  }, getButtonProps(isButton), otherProps), !!labelText && isLabelLeft && React.createElement(Paragraph, {
    weight: labelWeight
  }, labelText), React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, React.createElement("path", {
    d: getPath(name, path),
    fill: "currentColor"
  })), !!labelText && !isLabelLeft && React.createElement(Paragraph, {
    weight: labelWeight
  }, labelText));
};
Component.displayName = 'Icon';
Component.defaultProps = {
  className: null,
  color: null,
  hasBorder: false,
  isButton: false,
  isCircular: false,
  isColorInverted: false,
  isDisabled: false,
  isLabelLeft: false,
  labelText: null,
  labelWeight: null,
  name: null,
  path: null,
  size: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  color: PropTypes.oneOf(['black', 'blue', 'brown', 'green', 'grey', 'light grey', 'olive', 'orange', 'pink', 'primary', 'purple', 'red', 'teal', 'violet', 'yellow']),
  hasBorder: PropTypes.bool,
  isButton: PropTypes.bool,
  isCircular: PropTypes.bool,
  isColorInverted: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLabelLeft: PropTypes.bool,
  labelText: PropTypes.string,
  labelWeight: PropTypes.oneOf(['heavy', 'light']),
  name: PropTypes.oneOf(ICON_NAMES_LIST),
  path: PropTypes.string,
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'large', 'big', 'huge', 'massive'])
} : {};